module.exports = __webpack_public_path__ + "static/flags/BV-4a0c5bf397522f39911f01176ec35bc4.gif";